import { useContext } from 'react';
import clsx from 'clsx';

import UserGroupContext, {
  View,
} from '@atom/components/userGroupDetail/UserGroupContext';
import { Icon, IconButton } from '@atom/mui';
import { type IconComponent } from '@atom/mui/icons';
import colors from '@atom/styles/colors';

import classes from './userGroupHeader.module.css';

export interface Props {
  view: {
    value: View;
    label: string;
    icon: IconComponent;
  };
}

const DetailHeaderButton = ({ view }: Props) => {
  const { activeView, setActiveView } = useContext(UserGroupContext);

  return (
    <div
      onClick={() => setActiveView(view.value)}
      className={clsx(
        classes.iconContainer,
        activeView === view.value && classes.active,
      )}
    >
      <IconButton>
        <Icon color={colors.neutral.white} icon={view.icon} />
      </IconButton>
      <div className={classes.label}>{view.label}</div>
    </div>
  );
};

export default DetailHeaderButton;
